import { observer } from 'mobx-react';
import * as React from 'react';
import DemoMFEController from './DemoMFEController';
import { RootContext } from 'RootProvider';

const DemoMFEProvider = () => {
  const root = React.useContext(RootContext);
  return <DemoMFEController viewModel={root.auth} />;
};

export default observer(DemoMFEProvider);
